import http from './reddit'
/** 系统设定
 *  @param {any} setting
 *  
 */
const setting = {
  // 取得 水位设置列表
  getWaterLevel: (gameid) => http.Get(`${http.url.hfl}/pmtge/${gameid}`),
  // 修改 水位设置
  modifyWaterLevel: (gameid, data) => http.Post(`${http.url.hfl}/wlspo/${gameid}`, data),
  // // 取得 退水设置列表
  // getSendBackWatch: (gameid) => http.Get(`${http.url.six}/pmtge/${gameid}`),
  // // 修改 退水设置
  // modifySendBackWatch: (gameid, data) => http.Post(`${http.url.six}/pmtpo/${gameid}`, data),
  // 取得 自动跳水设置
  getAutoDiving: (key, url, gameid) => http.Get(`${http.url[key]}/${url}/${gameid}`),
  // 修改 自动跳水修改
  modifyAutoDiving: (key, url, gameid, data) => http.Post(`${http.url[key]}/${url}/${gameid}`, data),
  // // 取得 投注限制列表
  // getBettingLimit: (gameid) => http.Get(`${http.url.six}/pmtstge/${gameid}`),
  // // 修改 投注限制列表
  // modifyBettingLimit: (gameid, data) => http.Post(`${http.url.six}/pmtstpo/${gameid}`, data),
  // 取得 補貨設定列表
  getReplenishmentList: (gameid) => http.Get(`${http.url.hfl}/rpmeltge/${gameid}/1`),
  // 修改 补货設定
  modifyReplenishmentList: (gameid, data) => http.Post(`${http.url.hfl}/rpmeupo/${gameid}`, data),
  // 取得 雜項資料
  getMiscellaneous: () => http.Get(`${http.url.Newcommon}/mislt`),
  // 修改 雜項
  modifyMiscellaneous: (data) => http.Post(`${http.url.Newcommon}/misu`, data),
  // 取得 年度生肖
  getNowZodiac: () => http.Get(`${http.url.six}/sayzo/1`),
  // 切换 年度生肖
  chagneNowZodiac: (data) => http.Post(`${http.url.Newcommon}/upsayzo`, data),
  // 取得 額外站點設定檔
  getotherlist: () => http.Get(`${http.url.Newcommon}/otherlist`),
  // 修改 額外站點設定檔
  modifyotherlist: (data) => http.Post(`${http.url.Newcommon}/otherupd`, data),
  // 公告列表
  anlt: (gameid) => http.Get(`${http.url.Newcommon}/anlt/${gameid}`),
  // 新增公告
  anad: (data) => http.Post(`${http.url.Newcommon}/anad`, data),
  // 刪除公告
  adde: (data) => http.Post(`${http.url.Newcommon}/adde`, data),
  // 修改公告頁
  aduge: (adid) => http.Get(`${http.url.Newcommon}/aduge/${adid}`),
  // 修改公告
  adupo: (data) => http.Post(`${http.url.Newcommon}/adupo`, data),
  // 各站列表
  sitelist: () => http.Get(`${http.url.Newcommon}/site_use`),
}
export default setting